import { MetadataStore } from 'breeze-client';

import { AdminTimeCategory } from './admin-time-category';
import { Bill } from './bill';
import { BillDetail } from './bill-detail';
import { BillStatus } from './bill-status';
import { SetCapacity } from './set-capacity';
import { SetRateCalcDate } from './set-rate-calc-date';
import { SetRateSchedule } from './set-rate-schedule';
import { SetRecoveryStatus } from './set-recovery-status';
import { TimeCategory } from './time-category';
import { TimeEntry } from './time-entry';
import { TimeEntryImport } from './time-entry-import';
import { TimeEntryImportBill } from './time-entry-import-bill';
import { TimeEntryImportBillDetail } from './time-entry-import-bill-detail';
import { TimeEntryImportDetail } from './time-entry-import-detail';
import { TimeEntryStatus } from './time-entry-status';
import { TimeEntryTax } from './time-entry-tax';
import { TimeEntryType } from './time-entry-type';
import { TimeLock } from './time-lock';
import { TimeLockType } from './time-lock-type';
import { TimePractice } from './time-practice';
import { TimeUser } from './time-user';
import { UserTypeRate } from './user-type-rate';
import { UserUserType } from './user-user-type';
import { PositionType } from './position-type';
import { UserTypePositionType } from './user-type-position-type';

export class TimeRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('AdminTimeCategory', AdminTimeCategory);
        metadataStore.registerEntityTypeCtor('Bill', Bill);
        metadataStore.registerEntityTypeCtor('BillDetail', BillDetail);
        metadataStore.registerEntityTypeCtor('BillStatus', BillStatus);
        metadataStore.registerEntityTypeCtor('SetCapacity', SetCapacity);
        metadataStore.registerEntityTypeCtor('SetRateCalcDate', SetRateCalcDate);
        metadataStore.registerEntityTypeCtor('SetRateSchedule', SetRateSchedule);
        metadataStore.registerEntityTypeCtor('SetRecoveryStatus', SetRecoveryStatus);
        metadataStore.registerEntityTypeCtor('TimeCategory', TimeCategory);
        metadataStore.registerEntityTypeCtor('TimeEntry', TimeEntry);
        metadataStore.registerEntityTypeCtor('TimeEntryImport', TimeEntryImport);
        metadataStore.registerEntityTypeCtor('TimeEntryImportBill', TimeEntryImportBill);
        metadataStore.registerEntityTypeCtor('TimeEntryImportBillDetail', TimeEntryImportBillDetail);
        metadataStore.registerEntityTypeCtor('TimeEntryImportDetail', TimeEntryImportDetail);
        metadataStore.registerEntityTypeCtor('TimeEntryStatus', TimeEntryStatus);
        metadataStore.registerEntityTypeCtor('TimeEntryTax', TimeEntryTax);
        metadataStore.registerEntityTypeCtor('TimeEntryType', TimeEntryType);
        metadataStore.registerEntityTypeCtor('TimeLock', TimeLock);
        metadataStore.registerEntityTypeCtor('TimeLockType', TimeLockType);
        metadataStore.registerEntityTypeCtor('TimePractice', TimePractice);
        metadataStore.registerEntityTypeCtor('TimeUser', TimeUser);
        metadataStore.registerEntityTypeCtor('UserTypeRate', UserTypeRate);
        metadataStore.registerEntityTypeCtor('UserUserType', UserUserType);
        metadataStore.registerEntityTypeCtor('PositionType', PositionType);
        metadataStore.registerEntityTypeCtor('UserTypePositionType', UserTypePositionType);
    }
}
